import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} data - API response on success/error/loading
 * @param {String} type - type for sucess/error/loading
 */

export const onAdminDocumentSuccess = (
  payload = {},
  type = types.SUCCESS_ADMIN_DOCUMENT_LIST
) => {
  return {
    type,
    payload
  };
};

export const isAdminDocumentLoading = (
  payload = {},
  type = types.LOADING_ADMIN_DOCUMENT_LIST
) => {
  return {
    type,
    payload
  };
};
